import Breadcrumb from "../../Component/Breadcrumb";
function BusRules() {
  return (
    <>
      <Breadcrumb>Prospects /  Bus Routes</Breadcrumb>
      <div className="innersec vision_mission">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1> Bus Routes</h1>
            </div>
            <div className="col-lg-12">

              <h3>School Bus Facility </h3>
              <ul class="ul-list">
                <li>The school provides bus service for the commutation of students.</li>
                <li>The preference in given to the students from primary and junior class. The Conveyance facility is available for girls and boys.</li>
                <li>Conveyance fees will be charged for all twelve months; It is non refundable.</li>
                <li>Bus fee is taken in 2 instalments.</li>
                <li>Bus will run on prescribed routed and fixed days only. Conveyance fee is to be remitted in the Bank(Indian Overseas Bank, Barhalganj Branch).</li>
                <li>No admission for the same will be provided or cancelled during the academic session.</li>
                <li>Anyone who wants to discontinue the bus conveyance will have to pay the charge for the whole year and requested to submit an application in the school office.</li>
                <li>During the board examinations and the other examinations conducted separately for any particular class, the school bus shall not run to carry those students to the school.</li>
                <li>Admissions in the school doesn't guarantee admissions in the bus.</li>
                <li>Admissions in bus will be given according to the availability of the seats.</li>
                <li>Conveyance facility shall not be granted to less than a session. (12 months)</li>
              </ul>
              <br />
              <iframe
                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SJSKBUP/public/pdf/BusRoutes.pdf"
                width="100%"
                height="800px"
                style={{ border: "none" }}
                title="Bus Routes PDF"
              />

            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default BusRules;
